module.exports = __webpack_public_path__ + "Roboto-BlackItalic.woff?83b2c7d031cda66aadb97cd0fd29c1f4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlackItalic/Roboto-BlackItalic.woff?v=2.137
// module id = 672
// module chunks = 7